<template>
    <div name="uncomfortable">
        <navigation-bar 
            @change="change"
        />
        <router-view />
    </div>
</template>

<script>
import NavigationBar from '@/components/molecules/m_uncomfortable/NavigationBar'
export default {
  components: { NavigationBar },
    name: 'uncomfortable',
    mounted: function()
    {

        if(this.isPC())
        {
            const index = this.$route.path.indexOf('/m')
            if(index > -1)
            {

                this.$router.push({path: this.$route.path.substring(2, this.$route.path.length)})
            }


            
        }
    },  
    methods: {
        change: function(route)
        {
            this.$router.push({path: route})
        },
        isPC:function () {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipod|android|blackberry|windows phone|opera mini|iemobile|mobile/i.test(userAgent);
            return !isMobile;
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/m_uncomfortable/Uncomfortable.vue